module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date-input-wrapper"
  }, [_c('input', {
    staticClass: "date-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.dateString
    },
    on: {
      "change": _vm.onInput
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-22051c07!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/molecules/input-date/input-date.vue
// module id = 697
// module chunks = 4